import { ROOT } from "./index";
import { getAccessToken } from "@privy-io/react-auth";

export async function checkGeolocation() {
  return fetch(`${ROOT}geolocation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json" // Specify the content type
    }
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => console.error(error));
}

export const fetchAssets = async () => {
  try {
    const response = await fetch(`${ROOT}assets`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const assets = await response.json();
    return assets; // Return the data if needed
  } catch (err) {
    if (err instanceof Error) {
      if (err.message.includes("Failed to fetch") || err.message.includes("NetworkError")) {
        console.warn("Server may be down or unreachable (connection refused)");
        if (process.env.NODE_ENV !== "production") {
          //alert("Likely Server Is Down.  Make Sure Local Server Running on Port 3002");
        }
      } else {
        console.error("Other error:", err.message);
      }
    } else {
      console.error("Unknown error", err);
    }
  }
};

export async function joinWaitlist(email: string, selectedCompany: string) {
  return fetch(`${ROOT}join-waitlist`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json" // Specify the content type
    },
    body: JSON.stringify({ email, selectedCompany })
  })
    .then((response) => {
      if (!response.ok) {
        // If the response is not ok (e.g., status is 500), throw an error
        return response.json().then((json) => {
          throw new Error(json.message || "Server error");
        });
      }
      console.log("Test", response);
      return response.json(); // Otherwise, parse and return the JSON
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      throw error; // Re-throw the error to be caught by the caller
    });
}

export async function sendContactMessage(data: object): Promise<any> {
  const privyToken = await getAccessToken();
  console.log("Contact Message Data", data);
  return fetch(`${ROOT}contact/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json", // Specify the content type
      Authorization: `Bearer ${privyToken}` // Send Privy JWT
    },
    body: JSON.stringify(data) // Convert the data to a JSON string
  })
    .then((response) => response.json())
    .then((json) => {
      console.log("Successfully sent contact message", json);
      return json;
    })
    .catch((error) => {
      console.error("Failed to send contact message", error);
    });
}

export async function writeUserSelfAttestation() {
  const privyToken = await getAccessToken();

  return fetch(`${ROOT}users/self-attestation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${privyToken}`
    },
    body: JSON.stringify({ attestation: true })
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }
      return response.json();
    })
    .then((json) => {
      console.log("Self-Attestation Response:", json);
      return json;
    })
    .catch((error) => {
      console.error("Submit Self-Attestation Error:", error);
      throw error;
    });
}

export async function setUserHasDeposited() {
  const privyToken = await getAccessToken();

  return fetch(`${ROOT}users/has-deposited`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${privyToken}`
    },
    body: JSON.stringify({ hasDeposited: true })
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }
      return response.json();
    })
    .then((json) => {
      console.log("Has-Deposited Response:", json);
      return json;
    })
    .catch((error) => {
      console.error("Submit Has-Deposited Error:", error);
      throw error;
    });
}

export async function recordHeartbeat() {
  const privyToken = await getAccessToken();
  try {
    const response = await fetch(`${ROOT}heartbeat`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${privyToken}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ time: Date.now() })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Heartbeat failed:", response.status, errorText);
    } else {
      const data = await response.json();
      console.log("✅ Heartbeat recorded:", data);
    }
  } catch (err) {
    console.error("🔥 Error sending heartbeat:", err);
  }
}

export async function recordUserCompanyBalancesAsSnapshot(items: any[]) {
  const privyToken = await getAccessToken();

  const res = await fetch(`${ROOT}holdings/snapshot`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${privyToken}`
    },
    body: JSON.stringify({
      items
    })
  });

  if (!res.ok) {
    throw new Error("Failed to record holdings snapshot");
  }

  return res.json();
}
